import "./About.css";
import resume from "./TANISHA RAO2026v2.pdf";
import myimg from "./tanisha2026.jpeg"
function About() {
  return (
    <section className="about-container">
      <div className="about-card">
        
        <h1 className="about-title">About Me</h1>
        <div className="about-card-row1">
<img className="myImg" src={myimg}/>
<span>
        <p className="about-text">
          Hello, I’m <span className="highlight">Tanisha Rao</span> — a passionate
          developer who loves blending <strong>design</strong>,
          <strong> development</strong>, and <strong>problem-solving</strong>.
          I enjoy building complete systems — from clean user interfaces to
          powerful backend logic and structured databases.
        </p>
                <p className="about-text">
          Competitive programming sharpens my logical thinking, while web
          development lets me express creativity. I aim to build software that
          is not only functional, but intuitive and impactful.
        </p>

        
        </span></div>


<p className="last-updated">Last Updated: 17th Apr 2026</p>

        {/* TECH STACK */}
        <h2 className="section-title"> My Tech Stack</h2>

        <div className="tech-grid">
          <div className="tech-card frontend">
            <h3>Frontend</h3>
            {/* <p className="tech-desc">The dashboard & exterior — what users see</p> */}
            <ul>
              <li> React JS</li>
              <li> HTML</li>
              <li> CSS</li>
            </ul>
          </div>

          <div className="tech-card backend">
            <h3> Backend</h3>
            {/* <p className="tech-desc">The engine — powers the system</p> */}
            <ul>
              <li> Firebase (Auth, Functions)</li>
              <li> REST APIs</li>

            </ul>
          </div>

          <div className="tech-card programming">
            <h3>Programming</h3>
            {/* <p className="tech-desc">Driving skills & logic</p> */}
            <ul>
              <li> JavaScript</li>
              <li> C++</li>
              <li> Python</li>
              <li> Go</li>
            </ul>
          </div>

          <div className="tech-card database">
            <h3> Databases</h3>
            {/* <p className="tech-desc">Fuel tank & storage</p> */}
            <ul>
              <li> Firebase Firestore</li>
              <li> SQL</li>
              <li> PostgreSQL</li>
            </ul>
          </div>

          <div className="tech-card aicard">
            <h3> AI Engineer</h3>
            {/* <p className="tech-desc">Fuel tank & storage</p> */}
            <ul>
              <li> Generative AI</li>
              <li> Good at Prompting</li>
              <li> Claude API </li>
            </ul>
          </div>
        </div>

        {/* RESUME */}
        <div className="resume-section">
          <button
            className="resume-btn"
            onClick={() => window.open(resume, "_blank")}
          >
            📄 View Resume
          </button>
        </div>
      </div>
    </section>
  );
}

export default About;
